import { HashRouter as Router, Routes, Route } from 'react-router-dom';
// 1. Importe as páginas que você criou
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import FormPage from './pages/FormPage';
import ProfilePage from './pages/ProfilePage';
import ForgotPasswordRequest from './pages/ForgotPasswordRequest';
import ResetPassword from './pages/ResetPassword';
import Dashboard from './pages/DashBoard';
import InscricoesEncerradas from './pages/Encerradas';

function App() {
  return (
    // 2. O componente <Routes> envolve todas as suas rotas
    <Router>

      <Routes>


        {/* 3. Cada <Route> define uma URL e o componente que será exibido nela */}

        {/* Rota para a página de login (página inicial) */}
        <Route path="/" element={<LoginPage />} />

        {/* Rota para a página de cadastro */}
        <Route path="/cadastro" element={<RegisterPage />} />

        {/* Rota para a página do formulário de inscrição */}
        <Route path="/inscricao" element={<FormPage />} />

        <Route path="/perfil" element={<ProfilePage />} /> {/* <-- ADICIONAR ROTA */}
        <Route path="/recuperar-senha" element={<ForgotPasswordRequest />} />
        <Route path="/resetar-senha" element={<ResetPassword />} />

        <Route path="/dashboard" element={<Dashboard />} />

        {/* <Route path="/" element={<InscricoesEncerradas />} /> */}





      </Routes>

    </Router>
  );
}

export default App;


